import { EMPTY_OBJECT } from 'commons-ui';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/settings/role/edit',
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: '/settings/role/clone',
					state: {
						rowData
					}
				});
			};

		case 'add':
			return () => {
				history.push({
					pathname: '/settings/role/create'
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
